import React, { useEffect, useRef, useState } from 'react'
import { Animated, TextStyle, View, ViewStyle } from 'react-native'
import { useInterval, useStores } from '@trivie/core'
import { color } from '../../theme'
import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'

interface CountdownProps {
  setVisible: React.Dispatch<React.SetStateAction<boolean>>
  style?: ViewStyle
}

export const Countdown = observer((props: CountdownProps) => {
  const { userStore } = useStores()
  const { showBrandedSplash } = userStore

  const { t } = useTranslation()

  const { setVisible, style } = props
  const [seconds, setSeconds] = useState(3)
  const [countDownText, setCountDownText] = useState<string | undefined>(t('Quiz.getReady'))
  const [countdownColor, setCountdownColor] = useState(color.blue)
  const colors = [color.black, color.blue, color.yellow, '#00CB76']

  const countdownOpacity = useRef(new Animated.Value(100)).current

  const { uiStore } = useStores()

  useEffect(() => {
    if (!showBrandedSplash) {
      Animated.stagger(100, [
        Animated.timing(countdownOpacity, {
          toValue: 10.0,
          duration: 375,
          useNativeDriver: true,
        }),
        Animated.timing(countdownOpacity, {
          toValue: 0,
          duration: 200,
          useNativeDriver: true,
          delay: 500,
        }),
      ]).start()
    }
  }, [seconds])

  useInterval(() => {
    if (!showBrandedSplash) {
      if (seconds === 3) {
        setCountDownText(t('Quiz.getSet'))
      }
      if (seconds === 2) {
        setCountDownText(t('Quiz.go'))
      }
      if (seconds === 1) {
        setVisible(false)
      } else {
        setCountdownColor(colors[seconds])
        setSeconds(seconds - 1)
      }
    }
  }, 1000)

  return (
    <View style={{ ...FULL, backgroundColor: uiStore.branding.quiz_background, ...style }}>
      <Animated.Text
        allowFontScaling={false}
        style={{
          ...COUNTDOWN_TEXT,
          color: uiStore.branding.text_color,
          opacity: countdownOpacity.interpolate({
            inputRange: [0, 1],
            outputRange: [0, 1],
            extrapolate: 'clamp',
          }),
          fontFamily: uiStore.branding.font_family,
        }}
      >
        {countDownText}
      </Animated.Text>
      <Animated.Text
        allowFontScaling={false}
        style={{
          ...COUNTDOWN_SECONDS,
          color: countdownColor,
          opacity: countdownOpacity.interpolate({
            inputRange: [0, 1],
            outputRange: [0, 1],
            extrapolate: 'clamp',
          }),
          fontFamily: uiStore.branding.font_family,
        }}
      >
        {seconds.toString()}
      </Animated.Text>
    </View>
  )
})

const FULL: ViewStyle = {
  flex: 1,
  flexDirection: 'column',
  justifyContent: 'center',
}
const COUNTDOWN_SECONDS: TextStyle = {
  alignSelf: 'center',
  fontSize: 140,
  fontWeight: '800',
  lineHeight: 170,
}
const COUNTDOWN_TEXT: TextStyle = {
  color: color.white,
  fontSize: 40,
  lineHeight: 48,
  fontWeight: '800',
  textAlign: 'center',
}
